import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/App.css';
import './styles/Sidebar.css';
import './styles/FloatingNav.css';
import './styles/Section.css';
import './styles/Animation.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);